import React, { Component } from 'react';
import { store } from 'Store/store.index';
import {Spin, Tooltip, Popover} from 'antd';
import SharedUserList from 'Components/fwComponents/Shared/SharedUserList';
import SharedTableAction from 'Components/fwComponents/Shared/SharedTableAction';
//import {getQueryVariable} from 'utils/utils'
import downloadImg from 'assets/share/headerDownload.svg';
// import printImg from 'assets/share/printIcon.svg';
import moreIcon from 'assets/share/headeMorerIcon.svg';
import './CollaborationHeader.scss';
import { inject, observer } from 'mobx-react';
import SharedModel from 'Components/Shared/SharedModel';
import intl from 'react-intl-universal';
import { deepCopy, updateProp, windowActionFn, isCNDomain, isJPDomain } from '@/utils/utils';
// import { SAVE_TO_LOCAL } from '../viewer/ui/constants/event.constants.share';
import {
  SAVE_TO_LOCAL,
} from 'Components/viewer/ui/constants/savefile.constants';
import { DOWNLOAD_FILE_FAILED, DOWNLOAD_FILE_SUCCESS } from 'Components/viewer/ui/constants/user.more.constants';
import { Button } from '@/../node_modules/antd/lib/index';
import { DEVICE_DETACTION } from '@/utils/device';
import { collaborationApi } from '@/api/index';


@inject('collaborationStore' )
@observer
class CollaborationHeader extends Component {
  constructor(/*props*/) {
    super();
    this.detectAppRef = React.createRef()
    this.state = {
      showModel: false,
      modelContent: {},
    }
  }

  componentDidMount() {}
// TODO FOXIT 这个存储不使用了，转为使用原有头部保存
  downloadFileByBackend = async () => {
    const { hasSignIn } = store.userStore;
    if(!hasSignIn){
      store.appStore.doShowSignInDialog();
      return true;
    }
    if(store.appStore.isCollaborationMode()){
      store.userStore.doSendGAEvent({eventKey: SAVE_TO_LOCAL, label:'review_mode_upper_right_area'});
    }else{
      store.userStore.doSendGAEventByUser({eventKey:SAVE_TO_LOCAL, label:'upper_right_area'});
    }

    const { shareReviewData } = store.collaborationStore
    const {reviewSessionID, fileLink,docName} = shareReviewData
    const sendData = {
      confText: {
        listnewUrl: `reviewSessionID=${reviewSessionID}&getYourself=1&lastTime=0000-00-00%2000%3A00%3A00%3A000&pageObjNum=-1`,
      },
      documents: [{ url: fileLink }],
      filename: docName
    }

    store.collaborationStore.downloadFile(sendData, true).then(url => {
      if(url){
        window.location.href=url
      }
    })
  }
  downloadFile = async () => {
    const { hasSignIn } = store.userStore;
    const {saveToLocalComputer} = store.appStore;

    if(!hasSignIn){
      store.appStore.doShowSignInDialog();
      return true;
    }

    if(store.appStore.isCollaborationMode()){
      store.userStore.doSendGAEvent({eventKey: SAVE_TO_LOCAL, label:'review_mode_upper_right_area'});
    }else{
      store.userStore.doSendGAEventByUser({eventKey:SAVE_TO_LOCAL, label:'upper_right_area'});
    }

    if (saveToLocalComputer) {
      await collaborationApi.removeCDocId().catch((error) => {
        throw error
      })

      saveToLocalComputer({
        success:()=>{
          store.userStore.doSendGAEventByUserEvent(DOWNLOAD_FILE_SUCCESS, null, null);
        },
        error:()=>{
          store.userStore.doSendGAEventByUserEvent(DOWNLOAD_FILE_FAILED, null, null);

        }
      });
    }
  }

  setData = () => {
    const data = store.collaborationStore.shareReviewData;
    const formetData = store.collaborationStore.formetShareData(data);
    return {
      ...formetData,
      modelDateils: this.setModelDateils(formetData.cUserID==formetData.userId),
    };
  }

  actionSuccess = (type) => {
    store.collaborationStore.exitCollaboration(type === 'init');
  }
  setModelDateils = (isInitiator) => {
    const baseText = 'collaboration.sharedList.SharedTableAction';
    // const type = isInitiator ? 'your' : 'other'
    const textMap = {
      other: {
        title: `${baseText}.modelDeadlineSecondsTitle`,
        content: 'collaboration.Dlg.stopShare',
        confirmText: `${baseText}.modelDeadlineSecondsConfirmBtnText`,
      },
    };
    const {title,content,confirmText } = textMap['other'];
    return {
      title: intl.get(title),
      content: intl.get(content),
      confirmText: intl.get(confirmText),
      cancelText: intl.get(`${baseText}.modelCancelBtnText`),
      confirm: () => {
        store.collaborationStore.exitCollaboration(!isInitiator);
      }
    };
  }
  setWidth = (length) => {
    const clientWidth = document.documentElement.clientWidth;
    const listWidth = clientWidth/3 - 104;
    if(!length) return `${listWidth}px`;
    const lengthNum = parseInt((listWidth - 20)/16);
    return `${(lengthNum - 1)*16+20 - 4 - 6}px`;
  }
  getShareReviewInviteParticipant = (reviewSessionID,callback) => {
    store.collaborationStore.getShareReviewInviteParticipant(reviewSessionID).then(res => {
      const {ret, data} = res;
      if(ret === 0) {
        let {userId, avatar, isDefaultAvatar} = store.userStore;
        let guestTxt = intl.get('collaboration.sharedList.guest');
        let shareReviewData = deepCopy(store.collaborationStore.shareReviewData);
        let hasAvatar = false;
        let userName = '';
        shareReviewData.memberList = data.list;
        shareReviewData.people = data.list.map(item => {
          if(userId == item.cUserID) {
            store.userStore.updateUserName({showName: item.userName});
            pdfui.setUserName(item.userName);
            if(item.avatar) {
              hasAvatar = true;
              avatar = item.avatar;
              isDefaultAvatar = 0;
            }
          }
          if(item.isOwner === 1) {
            userName = item.userName;
          }
          const name = item.isGuest === 1 ? guestTxt : (item.userName || 'unknown');
          return {name, ...item};
        });
        shareReviewData.userName = userName;
        store.collaborationStore.setShareReviewData(shareReviewData);
        if(hasAvatar === true) {
          store.userStore.updateUserAvatar({avatar, isDefaultAvatar});
        }
        callback && callback(data.list);
      }
    }, error => { console.log(error); });
  }
  getSaveBtn = () => {
    return <Tooltip overlayClassName="header-create-dropdown" title={intl.get('collaboration.sharedList.SharedTableAction.DownloadBtn')}>
      <img className="downloadImgBtn" src={downloadImg} alt="" onClick={this.downloadFile} />
    </Tooltip>
  }
  onGoForDownload = () => {
    let targetUrl = 'https://www.foxit.com/downloads'
    const urlCN = 'https://www.foxitsoftware.cn/downloads'
    const urlJP = 'https://www.foxit.co.jp'

    if (isCNDomain()) {
      targetUrl = urlCN
    }
    if (isJPDomain()) {
      targetUrl = urlJP
    }

    windowActionFn(window, 'open', [targetUrl, '_blank']);
  }
  onCancelDownloadModel = () => {
    this.setState({
      showModel: false
    })
  }
  showDownloadDlgForMac = (type, affix) => {
    const baseText = 'collaboration.sharedList.DownloadDlg'
    const textMap = {
      downloadApp: {
        title: affix === 'Foxit PDF Editor' ? `${baseText}.titleEditor` : `${baseText}.titleReader`,
        content: `${baseText}.content`,
        confirmText: `${baseText}.confirmBtn`,
        cancelText: `${baseText}.cancelBtn`,
        replaceCancelText: `${baseText}.openBtn`,
        confirm: this.onGoForDownload,
        cancel: this.onCancelDownloadModel,
      },
    }
    const {title,content,confirmText, cancelText, confirm, cancel, replaceCancelText } = textMap[type]
    const replaceFn = () => {
      let res
      const { shareReviewData } = store.collaborationStore
      const cReviewLink = `${location.origin}/?docUrl=${encodeURIComponent(shareReviewData.fileLink)}&fileName=${encodeURIComponent(shareReviewData.docName)}&reviewSessionID=${shareReviewData.reviewSessionID}`
      
      switch (affix) {
        case 'Foxit PDF Editor':
          res = `FoxitPDFEditor://cReview/?cReviewLink=${cReviewLink}` //FoxitPhantomPDF
          break;
        case 'Foxit PDF Reader':
          res = `FoxitPDFReader://cReview/?cReviewLink=${cReviewLink}`
        default:
          break;
      }

      windowActionFn(window, 'open', [res, '_blank'])
    }

    this.setState({
      showModel: true,
      modelContent: {
        title: intl.get(title),
        content: intl.get(content, {type: affix === 'Foxit PDF Editor' ? intl.get(`${baseText}.titleEditor`) : intl.get(`${baseText}.titleReader`)}),
        confirmText: intl.get(confirmText),
        cancelText: intl.get(cancelText),
        replaceCancelText: intl.get(replaceCancelText),
        confirm,
        cancel,
        hideCancel: true,
        replaceCancel: true,
        replaceFn,
      }
    })
  }
  showDownloadDlg = (type, affix) => {
    const baseText = 'collaboration.sharedList.DownloadDlg'
    const textMap = {
      downloadApp: {
        title: affix === 'Foxit PDF Editor' ? `${baseText}.titleEditor` : `${baseText}.titleReader`,
        content: `${baseText}.content`,
        confirmText: `${baseText}.confirmBtn`,
        cancelText: `${baseText}.cancelBtn`,
        confirm: this.onGoForDownload,
        cancel: this.onCancelDownloadModel,
      },
    }
    const {title,content,confirmText, cancelText, confirm, cancel } = textMap[type]

    this.setState({
      showModel: true,
      modelContent: {
        title: intl.get(title),
        content: intl.get(content, {type: affix === 'Foxit PDF Editor' ? intl.get(`${baseText}.titleEditor`) : intl.get(`${baseText}.titleReader`)}),
        confirmText: intl.get(confirmText),
        cancelText: intl.get(cancelText),
        confirm,
        cancel,
      }
    })
  }
  onOpenPhantomForMac = (type) => {
    this.showDownloadDlgForMac('downloadApp', type)
  }
  onOpenPhantom = (type) => {
    let res
    let showDownloadDlg = true
    const { shareReviewData } = store.collaborationStore
    const cReviewLink = `${location.origin}/?docUrl=${encodeURIComponent(shareReviewData.fileLink)}&fileName=${encodeURIComponent(shareReviewData.docName)}&reviewSessionID=${shareReviewData.reviewSessionID}`
    const onblurFn = () => {
      showDownloadDlg = false
    }

    this.detectAppRef.current.onblur = onblurFn
    this.detectAppRef.current.focus();

    switch (type) {
      case 'Foxit PDF Editor':
        res = `FoxitPDFEditor://cReview/?cReviewLink=${cReviewLink}` //FoxitPhantomPDF
        break;
      case 'Foxit PDF Reader':
        res = `FoxitPDFReader://cReview/?cReviewLink=${cReviewLink}`
      default:
        break;
    }

    updateProp(location, 'href', res)
    setTimeout(() => {
      this.detectAppRef.current.onblur = null

      if (showDownloadDlg) {
        this.showDownloadDlg('downloadApp', type)
      }
    }, 500);
  }
  getOpenInPhantomContent = () => {
    return (
      <React.Fragment>
        <div className="menu-item" onClick={this.onOpenPhantom.bind(this, 'Foxit PDF Editor')}>{intl.get('collaboration.OpenInFoxitPDFEditor')}</div>
        <div className="menu-item" onClick={this.onOpenPhantom.bind(this, 'Foxit PDF Reader')}>{intl.get('collaboration.OpenInFoxitPDFReader')}</div>
      </React.Fragment>
    );
  }
  getOpenInPhantomContentForMac = () => {
    return (
      <React.Fragment>
        <div className="menu-item" onClick={this.onOpenPhantomForMac.bind(this, 'Foxit PDF Editor')}>{intl.get('collaboration.OpenInFoxitPDFEditor')}</div>
        <div className="menu-item" onClick={this.onOpenPhantomForMac.bind(this, 'Foxit PDF Reader')}>{intl.get('collaboration.OpenInFoxitPDFReader')}</div>
      </React.Fragment>
    );
  }

  getWrapOpenFoxit = () => {
    return (
      <React.Fragment>
        <div className="wrapOpenFoxit">
          {DEVICE_DETACTION.windows && <Popover getTooltipContainer={triggerNode => triggerNode.parentNode} className="open-collaboration-in-phantom" content={this.getOpenInPhantomContent()}>
            <Button className='openFoxit'>{intl.get('collaboration.OpenInFoxit')}</Button>
          </Popover>}
          {
            DEVICE_DETACTION.mac && <Popover getTooltipContainer={triggerNode => triggerNode.parentNode} className="open-collaboration-in-phantom" content={this.getOpenInPhantomContentForMac()}>
              <Button className='openFoxit'>{intl.get('collaboration.OpenInFoxit')}</Button>
            </Popover>
          }
        </div>
        <span className="divide-line"></span>
      </React.Fragment>
    )
  }
  render() {
    const { showModel, modelContent } = this.state
    const {showDeadlineModel} = store.collaborationStore;
    const {fileDetails, reviewSessionID, cDocID, fileLink,type,people, loading, shareState,modelDateils} = this.setData();
    const { inTeamsApp } = store.teamsAppStore;
    const { shareUserType } = store.shareCollaborationStore // 标识是否为企业用户协同分享
    console.log("?????")
    console.log(shareUserType)
    return (
      <div className={'CollaborationHeader ' + shareUserType ? 'shareCollaborationHeader' : 'CollaborationHeader'}  lng={store.appStore.lng.full}>
        { !inTeamsApp && !shareUserType && this.getWrapOpenFoxit()}
        <SharedUserList parentCom='CollaborationHeader' peopleList={people} reviewSessionID={reviewSessionID} outerInviteParticipant={this.getShareReviewInviteParticipant} cDocID={cDocID} fileLink={fileLink} type={type} shareState={shareState} />
        {/* 去除保存按钮，使用云编辑保存逻辑 */}
        {/* {this.getSaveBtn()} */}
        {/* 去除打印按钮 */}
        {/* <img src={printImg} alt="" onClick={this.props.printBtn}/> */}
        {
          !shareUserType && <SharedTableAction parentCom='CollaborationHeader' data={fileDetails} type={type} icon={moreIcon} updateTableList={this.actionSuccess}  reviewSessionID={reviewSessionID}  cDocID={cDocID} fileLink={fileLink}/>
        }
        {
          !shareUserType && <span className="divide-line"></span>
        }
        {loading&&!shareUserType && <Spin />}
        {
          !shareUserType && <SharedModel visible={showDeadlineModel} detailsData={modelDateils} hideCancel={true}  replaceCancel={modelContent.replaceCancel}/>
        }
        {
          !shareUserType && <SharedModel visible={showModel} detailsData={modelContent}  hideCancel={modelContent.hideCancel} replaceCancel={modelContent.replaceCancel}/>
        }
        {/* {
          !shareUserType && <input ref={this.detectAppRef} className="detect-app" />
        } */}
      </div>
    );
  }
}

export default CollaborationHeader;
